import React, { useEffect, useState } from 'react';
import 'leaflet/dist/leaflet.css';
import { useDispatch, useSelector } from 'react-redux';
import pin from '../../assets/images/pin.png';
import { Icon } from 'leaflet';
import Datagrid from '../ui/Datagrid';
import { masterColumn } from './table_config';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { MAP_TYPES } from '../../shared/config/constants';
import Map from '../map';
import { gridClasses, useGridApiRef } from '@mui/x-data-grid-pro';
import { listPayTargets } from '../../store/actions/payTargets';
import ReactJson from 'react-json-view';

const PayTargets = () => {
  const payTargets = useSelector((state) => state.payTargets);
  const [rowId, setRowId] = useState(null);
  const [gmapRowId, setGmapRowId] = useState(null);
  const [iconPinSize, setIconPinSize] = useState([15, 25]);
  const mapType = process.env.REACT_APP_FIELD_BOXES_PAGE_MAP;

  const dispatch = useDispatch();
  const apiRef = useGridApiRef();

  useEffect(() => {
    if (!payTargets.loading && payTargets.data.length === 0) {
      dispatch(listPayTargets());
    }
  }, []);

  const renderJsonField = ({ value }) => {
    let data = {};
    if (typeof value === 'object' || (Array.isArray(value) && value !== null)) {
      data = value;
    }
    return (
      <ReactJson src={data} name={false} collapsed={true} sortKeys={true} />
    );
  };

  const getGoogleMapPin = () => {
    return {
      url: pin,
      // eslint-disable-next-line no-undef
      scaledSize: new google.maps.Size(iconPinSize[0], iconPinSize[1]),
      // eslint-disable-next-line no-undef
      size: new google.maps.Size(iconPinSize[0] + 10, iconPinSize[1] + 10)
    };
  };

  const getMapPin = () => {
    return (
      new Icon({
        iconUrl: pin,
        iconSize: iconPinSize,
        popupAnchor: [0, -5],
      })
    );
  };

  return (
    <Grid container justifyContent="center" sx={{ height: 'calc(100vh - 80px)', flexDirection: 'column' }}>
      <Grid item>
        <Map
          mapType={mapType}
          data={payTargets}
          mapData={payTargets.data}
          markerData={payTargets.data}
          latitudeField={'lat'}
          longitudeField={'long'}
          mapPinField1={'RigName_Number'}
          mapPinField2={'question'}
          popUpLabel={['RigName_Number', 'question']}
          getGoogleMapPin={getGoogleMapPin}
          showMaxDate={['lastUpdate']}
          getMapPin={getMapPin}
          gmapRowId={gmapRowId}
          rowId={rowId}
          setIconPinSize={setIconPinSize}
          excludePopupLabel={true}
          resizable={true}
        />
      </Grid>
      <Grid item sx={{ flex: 1, minHeight: 0 }}>
        <Datagrid
          data={payTargets.data}
          apiRef={apiRef}
          columns={masterColumn(renderJsonField)}
          loading={payTargets.loading}
          getRowHeight={() => 'auto'}
          onRowClick={({ row: target }) => {
            if (mapType === MAP_TYPES.GOOGLEMAP) {
              setGmapRowId(target._id);
            } else {
              setRowId(target);
            }
          }}
          sx={{
            '.MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold !important',
            },
            '.MuiDataGrid-cell': {
              fontSize: 'medium',
              fontWeight: 'bold !important'
            },
            [`& .${gridClasses.cell}`]: {
              py: 1,
            },
          }}
          toolbar={{
            options: {
              columns: true,
              filters: true,
              export: false,
            },
          }}
          pageSize={100}
          autoHeight={false}
          height='100%'
        />
      </Grid>
    </Grid>
  );
};

PayTargets.propTypes = {
  row: PropTypes.object,
};

export default PayTargets;
